<template>
  <div
    class="video-play-page"
    :class="{
      'video-play-page__h5': isH5,
      'video-play-page__electron': isElectron,
      'portrait-mode': isH5PortraitMode,
    }"
  >
    <div
      class="video-play-content"
      :class="{
        'ai-mode-video-play-content': openAiMode,
      }"
    >
      <nav-bar
        class="video-play-nav-bar"
        :class="{ 'white-bg': changeNavBarBg }"
        v-if="!isH5 && !isElectron"
      />
      <div class="content-wrap">
        <div class="left-cont-wrap">
          <video-card
            ref="videoCard"
            :lessonInfo="lessonInfo"
            :courseInfo="courseInfo"
            @changeAiMode="openAiModeChange"
            @saveNote="handleSaveNote"
            :openAiMode="openAiMode"
            @videoPlayerBoxHeight="handleVideoPlayerBoxHeight"
            @changeLesson="onChangeLesson"
            :noteComponentId="noteComponentId"
            @videoOrientation="onVideoOrientationDetected"
          />
          <!-- 切片列表 -->
          <video-slice-list
            v-if="openAiMode"
            @playCurNode="handlePlayCurNode"
            :courseId="courseId"
            :lessonId="Number(lessonId)"
            :videoDuration="handleVideoDuration"
          />
        </div>
        <tabs
          ref="h5Tabs"
          v-if="isH5"
          class="tabs-box"
          :tabs-data="tabsData"
          @change="changeTab"
        />
        <right-operation-cont
          v-if="openAiMode"
          :videoPlayerBoxHeight="videoPlayerBoxHeight"
          :lesson-info="lessonInfo"
          :course-info="courseInfo"
          :activeTab="activeTab"
          @changeLesson="onChangeLesson"
          :havePrivateLesson="courseInfo.havePrivateLesson || 0"
          @playCurNode="handlePlayCurNode"
        />
        <course-card
          :noteComponentId="noteComponentId"
          v-else
          :lesson-info="lessonInfo"
          :course-info="courseInfo"
          :activeTab="activeTab"
          @changeLesson="onChangeLesson"
          :havePrivateLesson="courseInfo.havePrivateLesson || 0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from "vuex";
import usePortraitVideo from "./mixins/usePortraitVideo";
import RightOperationCont from "./ai-mode/RightOperationCont.vue";
import VideoSliceList from "./ai-mode/VideoSliceList.vue";
import { NavBar } from "@saas/components/src";
import { getCourseInfo } from "@saas/server-api/src/product-details";
import CourseCard from "./components/CourseCard.vue";
import VideoCard from "./components/VideoCard.vue";
import Tabs from "./components/Tabs.vue";
import {
  isH5,
  isHXApp,
  isMobile,
  getLessonIdFromReplayWinUrl,
} from "@saas/components/src/utils/utils";
import { EventBus } from "@saas/components/src/utils/event-bus";
export default {
  name: "VideoPlay",
  mixins: [usePortraitVideo],
  props: {},
  provide() {
    return {
      registerComponent: this.registerComponent,
      unregisterComponent: this.unregisterComponent,
    };
  },
  data() {
    return {
      openAiMode: false,
      changeNavBarBg: false,
      activeId: 1,
      courseId: null,
      lessonId: null,
      unitId: null,
      lessonInfo: {},
      courseInfo: {},
      isH5: isH5(),
      isElectron: window.isElectron,
      tabsData: [
        {
          title: "简介",
          isActive: false,
          type: "desc",
        },
        {
          title: "目录",
          isActive: true,
          type: "folder",
        },
      ],
      activeTab: "folder",
      videoPlayerBoxHeight: 0,
      noteComponentId: "video-play-note",
      registeredComponents: new Set(),
    };
  },
  mounted() {
    // 将绿色渐变背景设置到 #app，使整个视口背景一致
    const appEl = document.getElementById('app');
    if (appEl) {
      this._prevAppBg = appEl.style.background;
      appEl.style.background = 'linear-gradient(180deg, #e3f8eb 0%, #e3f8eb 100%)';
    }

    const { courseId = 0, unitId = 0, lessonId = 0 } = this.$route.params;
    const lsIds = JSON.parse(localStorage.getItem("video_play_ids") || "{}");
    if (Object.keys(lsIds).length) {
      this.lessonId = lsIds.lessonId;
      this.unitId = lsIds.unitId;
      this.courseId = lsIds.courseId;
    } else {
      this.courseId = courseId;
      this.unitId = unitId;
      this.lessonId = lessonId;
    }
    //处理带有time播放位置参数的情况
    if (this.$route?.query?.time) {
      this.setUrlProgressTime(Number(this.$route.query.time));
    }
    // this.getLessonDetail();
    this.getCourseInfo();
    // 获取切片列表：判断是否可开启ai模式
    this.apiGetLessonOutline({ lesson_id: Number(this.lessonId) });

    // 监听滚动
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("keydown", this.handleKeydown, false);
    if (window.isElectron) {
      window.ipcRenderer.on("refresh-login-win", this.refreshPage);
      window.ipcRenderer.on("replay-win-close", this.handleReplayWinClose);
    }
  },
  beforeDestroy() {
    // 恢复 #app 背景
    const appEl = document.getElementById('app');
    if (appEl) {
      appEl.style.background = this._prevAppBg || '';
    }

    // 移除监听
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener("keydown", this.handleKeydown, false);
    if (window.isElectron) {
      window?.ipcRenderer?.removeListener(
        "refresh-login-win",
        this.refreshPage
      );
      window.ipcRenderer.removeListener(
        "replay-win-close",
        this.handleReplayWinClose
      );
      localStorage.removeItem("video_play_ids");
    }
  },
  beforeRouteLeave(to, from, next) {
    const noteComp = this.findComponent("Notes");
    if (noteComp) {
      noteComp.checkLeaveStatus(next);
    } else {
      next();
    }
  },
  methods: {
    ...mapMutations("replay", [
      "setInitNoteContent",
      "apiGetLessonOutline",
      "setUrlProgressTime",
    ]),
    ...mapActions("replay", ["apiGetLessonOutline"]),
    handleReplayWinClose(event, params) {
      console.log(params, "handleReplayWinClose======");
      if (!params?.url) {
        return;
      }
      const lessonId = getLessonIdFromReplayWinUrl(params.url);
      console.log(lessonId, "handleReplayWinClose--lessonId======");
      if (Number(lessonId) === Number(this.lessonId)) {
        console.log("emit-video-play-note-update", {
          lessonId: this.lessonId,
        });

        EventBus.$emit("video-play-note-update", {
          lessonId: this.lessonId,
        });
      }
    },
    // 保存笔记
    handleSaveNote() {
      const noteComp = this.findComponent("Notes");
      if (noteComp) {
        noteComp.onClickSave(false);
      }
    },
    handleVideoPlayerBoxHeight(height) {
      this.videoPlayerBoxHeight = height;
    },
    openAiModeChange() {
      this.setInitNoteContent();
      if (!window.isElectron) {
        // 隐藏footer：防止切片展开时高度变化，底部footer会跳动
        let footerEl = document.querySelector("footer.footer");
        if (footerEl) {
          if (!this.openAiMode) {
            footerEl.style.display = "none";
          } else {
            footerEl.style.display = "block";
          }
        }
      }
      this.openAiMode = !this.openAiMode;
      this.handleSaveNote();
    },
    handlePlayCurNode(duration) {
      if (this.$refs.videoCard) {
        this.$refs.videoCard.playToDuration(duration);
      }
    },
    refreshPage() {
      console.log("refresh-login-win======");
      setTimeout(() => {
        window.location.reload();
      }, 2500);
    },
    // 监听键盘
    handleKeydown(e) {
      if (e.key === " ") {
        e.preventDefault();
      }
    },
    // 获取课程详情数据
    getCourseInfo() {
      getCourseInfo({
        course_id: this.courseId,
      }).then((res) => {
        if (res.code === 1) {
          this.courseInfo = res.data || {};
          this.havePrivateLesson();
          const unitList = res.data.unit_list || [];
          const lessonList = [];
          unitList.forEach((item) => {
            if (item?.lesson_list?.length) {
              lessonList.push(...item.lesson_list);
            }
            // if (+item.id === +this.unitId) {
            //   const lessonInfo = (item.lesson_list || []).find(lesson => +lesson.id === +this.lessonId)
            //   if (lessonInfo) {
            //     this.lessonInfo = JSON.parse(JSON.stringify(lessonInfo));
            //   }
            // }
          });
          const lessonInfo = lessonList.find(
            (lesson) => +lesson.id === +this.lessonId
          );
          if (lessonInfo) {
            this.lessonInfo = lessonInfo;
            this.unitId = this.lessonInfo.unit_id;
          } else if (this.courseInfo.havePrivateLesson) {
            // 有私教课
            const privateUnitList = res.data.private_unit_list;
            const privateLessonList = [];
            privateUnitList.forEach((item) => {
              privateLessonList.push(...item.lesson_list);
            });
            const privateLessonInfo = privateLessonList.find(
              (lesson) => +lesson.id === +this.lessonId
            );
            console.log(privateLessonInfo.id, "privateLessonInfo======1111");
            if (privateLessonInfo) {
              if (this.isH5) {
                this.activeTab = "private";
                let index = 0;
                this.tabsData.forEach((tab, i) => {
                  if (tab.type === this.activeTab) {
                    index = i;
                    tab.isActive = true;
                  } else {
                    tab.isActive = false;
                  }
                });
                setTimeout(() => {
                  this.$refs["h5Tabs"].updateIndicatorPosition(index);
                }, 500);
              }
              this.lessonInfo = privateLessonInfo;
              this.lessonInfo.isPrivate = true;
              this.unitId = this.lessonInfo.unit_id;
            } else {
              this.lessonInfo = lessonList[0] || {};
              this.unitId = this.lessonInfo.unit_id;
            }
          } else {
            this.lessonInfo = lessonList[0] || {};
            this.unitId = this.lessonInfo.unit_id;
          }
        } else if (res.code === 6666) {
          this.$showErrorPage({
            tips: "课程不存在",
          });
        } else {
          this.$showErrorPage();
        }
      });
    },
    // 获取课时详情数据
    // getLessonDetail() {
    //   getLessonDetail({
    //     course_id: this.courseId,
    //     lesson_id: this.lessonId,
    //   }).then((res) => {
    //     if (res.code === 1) {
    //       this.lessonInfo = res.data || {};
    //     } else if (res.code === 40000) {
    //       // 未报名或者不在课程有效期内
    //       this.$message.error(res.message);
    //       // setTimeout(() => {
    //       //   this.$router.push({ name: "myCourse" });
    //       // }, 1500);
    //     } else if (res.code === 40007) {
    //       // 开启网页防火墙
    //       this.$router.replace("/firewall/" + this.courseId);
    //     } else {
    //       this.$message.error(res?.message || "请求失败");
    //     }
    //   });
    // },
    handleMouseEnter(id) {
      this.activeId = id;
      let elImageWrap = document.querySelector(".img-wrap");
      if (elImageWrap) {
        elImageWrap.scrollTop = 541 * (id - 1);
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement?.scrollTop || 0;
      let height = document.querySelector(".nav-bar")?.offsetHeight || 0;
      if (scrollTop > height) {
        this.changeNavBarBg = true;
      } else {
        this.changeNavBarBg = false;
      }
    },
    onChangeLesson(lesson) {
      this.setUrlProgressTime(null);
      this.lessonId = lesson.id;
      this.lessonInfo = lesson;
      if (!window.isElectron) {
        this.$router.replace({
          path: `/video-play/${this.courseId}/${this.unitId}/${this.lessonId}`,
        });
      } else {
        localStorage.setItem(
          "video_play_ids",
          JSON.stringify({
            lessonId: this.lessonId,
            unitId: this.unitId,
            courseId: this.courseId,
          })
        );
      }
      // 获取切片列表：判断是否可开启ai模式
      this.apiGetLessonOutline({ lesson_id: this.lessonInfo.id });
    },
    changeTab(tab) {
      this.activeTab = tab.type;
    },
    havePrivateLesson() {
      let length = this.courseInfo?.private_unit_list?.length;
      let data = this.tabsData.find((tab) => {
        return tab.type === "private";
      });
      if (!data && length) {
        this.tabsData.push({
          title: "私教课",
          isActive: false,
          type: "private",
        });
      }
      this.courseInfo.havePrivateLesson = length;
    },
    registerComponent(component) {
      this.registeredComponents.add(component);
    },
    unregisterComponent(component) {
      this.registeredComponents.delete(component);
    },
    findComponent(componentName) {
      for (const component of this.registeredComponents) {
        if (component.$options.name === componentName) {
          return component;
        }
      }
      return null;
    },
  },
  computed: {
    handleVideoDuration() {
      let videoDuration =
        this.$refs?.videoCard?.$refs?.videoPlayer?.videoDuration || 0;
      return videoDuration;
    },
  },
  components: {
    "nav-bar": NavBar,
    CourseCard,
    VideoCard,
    Tabs,
    VideoSliceList,
    RightOperationCont,
  },
};
</script>

<style scoped lang="scss">
.video-play-page {
  min-width: 1200px;
  width: 100%;
  .video-play-content {
    &.ai-mode-video-play-content {
      min-height: 100vh;
    }
    min-height: calc(100vh - 234px);
    background: url("../../assets/images/video-play/bg.png");
    background-position: top center;
    background-size: 100% auto;
    background-repeat: no-repeat;
    display: flex;
    .content-wrap {
      flex: 1;
      display: flex;
      flex-direction: row;
      padding: 40px 100px 54px;
      margin-top: 70px;
    }
  }
  ::v-deep .video-play-nav-bar {
    .nav-bar {
      background: rgba($color: #fff, $alpha: 0.4);
      z-index: 1999;
      padding: 0 100px;
      .menu-row {
        width: unset;
      }
    }
  }
  ::v-deep .white-bg.video-play-nav-bar {
    .nav-bar {
      background: #fff;
    }
  }
  .left-cont-wrap {
    flex: 1;
    width: 0;
  }
}
.video-play-page__h5 {
  min-width: unset;
  width: 100%;
  min-height: calc(100vh - #{$h5-footer-height});
  .left-cont-wrap {
    flex: 1;
    width: 100%;
  }
  .video-play-content {
    min-height: unset;
    .content-wrap {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0;
      margin-top: 0;
      // margin-top: 1.6rem;
      .tabs {
        display: flex;

        .tab {
          flex: 1;
          text-align: center;
          padding: 0.4rem 0;
          font-size: 0.4rem;
          color: #333;
          border-bottom: 0.01rem solid #ccc;
        }
      }
    }
  }
}
// 竖屏视频模式
.portrait-mode {
  --tab-bar-h: 1.12rem;

  ::v-deep .video-area {
    height: var(--video-h, 70vh);
    will-change: height;

    &.pv-snapping {
      transition: height 0.3s ease;
    }

    .video-player-box {
      height: 100%;
    }
  }

  ::v-deep .course-info-area.h5-course-info {
    height: calc(100vh - var(--video-h, 70vh) - var(--tab-bar-h, 1.12rem));
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
}
.video-play-page__electron {
  height: calc(100vh - #{$nav-height});
  .video-play-content {
    min-height: unset;
    max-height: 100%;
    .content-wrap {
      padding: 45px 24px 45px;
      margin-top: 0;
      .tabs {
        display: flex;
      }
    }
  }
}
</style>
